/**
 * Validación de fechas del API. Un valor vacío, "Sin fecha" o cualquier texto
 * que no sea una fecha real da `false`, así la UI omite la fecha en vez de
 * mostrar «NaN» o «Invalid Date».
 */
export const fechaOk = (v) => !!v && !Number.isNaN(new Date(v).getTime());
